module.exports = __webpack_public_path__ + "img/CM-AB-25-INFINITI-Modern.44d635b4.jpg";